import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Toast } from './Toast';
import { CartDrawer } from './CartDrawer';
import { MenuDrawer } from './MenuDrawer';
import { useUI } from '@/context/UIContext';

export function Layout() {
  const { drawer, closeDrawer } = useUI();
  const { pathname } = useLocation();

  // New page: start at the top and close any open panel.
  useEffect(() => { window.scrollTo(0, 0); closeDrawer(); }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <a className="skip" href="#main">Skip to content</a>
      <Header />
      <main id="main" tabIndex={-1}>
        <Outlet />
      </main>
      <Toast />
      <div className={'scrim' + (drawer ? ' on' : '')} onClick={closeDrawer} aria-hidden="true" />
      <CartDrawer />
      <MenuDrawer />
    </>
  );
}
